// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yuYxv","label":"styles_label__2wx5F"};